module.exports = __webpack_public_path__ + "static/media/04_JBL_Quantum.7c0a5739.png";